// extracted by mini-css-extract-plugin
export default {"myBtn":"MyButton_myBtn__YDXOj","deleteBtn":"MyButton_deleteBtn__61y6y"};